import { Box, Typography, Tabs, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import FilterWrapperBottomSheet from "./FilterWrapperBottomSheet";
import FilterButton from "./filterTab/filterButton";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import filterContent from "./filterTab/staticContent/filter.content";

function FilterWrapper({
  loading,
  filterBarVisibility,
  setFilterBarVisibility,
  filters,
  setFilters,
  resetFilters,
  hasFilter,
}) {
  const DefaultTab = "depositGroup";

  const [defaultTypeValue, setDefaultTypeValue] = useState(DefaultTab);
  const [fakeTab, setFakeTab] = useState("none");

  const handleChange = (event, newValue) => {
    if (loading) return false;
    setFakeTab(newValue);
    if (newValue == "reset") reset();
    else showFilterBottomSheet(newValue);
  };

  const reset = () => {
    resetFilters();
    setFilterBarVisibility(false);
    setDefaultTypeValue(DefaultTab);
    setFakeTab("none");
  };

  const showFilterBottomSheet = (groupType) => {
    setDefaultTypeValue(groupType);
    setFilterBarVisibility(true);
  };

  const closeFilterBar = () => {
    setDefaultTypeValue(DefaultTab);
    setFilterBarVisibility(false);
    setFakeTab("none");
  };

  useEffect(() => {
    if (!filterBarVisibility) setFakeTab("none");
  }, [filterBarVisibility]);

  return (
    <>
      <Tabs
        value={fakeTab}
        onChange={handleChange}
        variant="scrollable"
        p={0}
        m={0}
        scrollButtons={false}
        aria-label="scrollable prevent tabs"
        sx={{
          borderBottom: 0,
          ".MuiTabs-indicator": {
            display: "none",
          },
          ".Mui-focusVisible": {
            background: "none",
          },
          ".MuiTab-root": {
            padding: "5px",
            minWidth: "auto",
            ".MuiBox-root": {
              margin: 0,
            },
          },
          ".MuiTouchRipple-root ": {
            opacity: 0,
          },
        }}
      >
        <Tab
          label={
            <Box
              onClick={() => {
                setFilterBarVisibility(true);
              }}
              sx={{
                minHeight: 32,
                px: "8px",
                py: "4px",
                borderRadius: "8px",
                border: (theme) => `1px solid ${theme.palette.primary.main}`,
                bgcolor: "common.white",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FilterIcon width={24} height={24} />
              <Typography variant="button" color="primary.main">
                فیلتر‍
              </Typography>
            </Box>
          }
          value={"none"}
        />

        {filters?.depositGroup && filters.depositGroup?.length > 0 && (
          <Tab
            label={
              <FilterButton
                title={"واریز"}
                length={filters.depositGroup.length}
              />
            }
            value={"depositGroup"}
          />
        )}

        {filters?.withdrawGroup && filters.withdrawGroup?.length > 0 && (
          <Tab
            label={
              <FilterButton
                title={"برداشت"}
                length={filters.withdrawGroup.length}
              />
            }
            value={"withdrawGroup"}
          />
        )}

        {filters?.statusGroup && (
          <Tab
            label={
              <FilterButton
                title={
                  filters.statusGroup == "ALL"
                    ? filterContent.all
                    : filterContent[filters.statusGroup]
                }
                length={null}
              />
            }
            value={"statusGroup"}
          />
        )}

        {filters?.date && (
          <Tab
            label={
              <FilterButton
                title={
                  filters.date == "ALL"
                    ? filterContent.allDate
                    : filterContent[filters.date]
                }
                length={null}
              />
            }
            value={"date"}
          />
        )}

        {hasFilter() && (
          <Tab
            label={
              <Typography
                fontSize={12}
                ml={1}
                variant="span"
                color="grey.8"
                sx={{
                  display: "flex",
                }}
              >
                حذف فیلترها
              </Typography>
            }
            value={"reset"}
          />
        )}
      </Tabs>

      <FilterWrapperBottomSheet
        filters={filters}
        setFilters={setFilters}
        reset={reset}
        closeFilterBar={closeFilterBar}
        filterBarVisibility={filterBarVisibility}
        defaultTypeValue={defaultTypeValue}
      />
    </>
  );
}

export default FilterWrapper;
